import { render, staticRenderFns } from "./SampleCompactCard.vue?vue&type=template&id=6e437c48&scoped=true&"
import script from "./SampleCompactCard.vue?vue&type=script&lang=js&"
export * from "./SampleCompactCard.vue?vue&type=script&lang=js&"
import style0 from "./SampleCompactCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SampleCompactCard.vue?vue&type=style&index=1&id=6e437c48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e437c48",
  null
  
)

export default component.exports